const FontAssets = {
  'Graphik-Light': require('./Graphik-Light-App.ttf'),
  'Graphik-Medium': require('./Graphik-Medium-App.ttf'),
  'Graphik-Regular': require('./Graphik-Regular-App.ttf'),
}

export default FontAssets
